
// redux/slices/adminLeaveSlice.js - COMPLETE FIXED VERSION

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axiosInstance'; // ✅ Correct import

// ✅ Get ALL Pending Leaves - FIXED
export const getAllPendingLeaves = createAsyncThunk(
    'adminLeave/getAllPending',
    async (_, { rejectWithValue }) => {
        try {
            console.log("🔄 Fetching pending leaves from admin API...");
            const response = await axiosInstance.get('/api/leaves/admin/pending');
            
            console.log("📊 Admin API Response:", response.data);
            
            if (response.data.status && response.data.data) {
                console.log(`✅ Found ${response.data.data.length} pending leaves`);
                return response.data;
            } else {
                return rejectWithValue({ 
                    message: response.data.message || "No data received" 
                });
            }
        } catch (error) {
            console.error("❌ Admin Leaves API Error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// ✅ Get Leave Statistics - FIXED
export const getLeaveStats = createAsyncThunk(
    'adminLeave/getStats',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/api/leaves/admin/stats');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// ✅ Update Leave Status - FIXED
export const updateLeaveStatus = createAsyncThunk(
    'adminLeave/updateStatus',
    async ({ leaveId, status, approvedBy, remarks }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(
                `/api/leaves/admin/status/${leaveId}`,
                { status, approvedBy, remarks }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// ✅ Slice - FIXED
const adminLeaveSlice = createSlice({
    name: 'adminLeave',
    initialState: {
        pendingLeaves: [],
        stats: {},
        loading: false,
        error: null,
        success: false
    },
    reducers: {
        resetAdminLeave: (state) => {
            state.pendingLeaves = [];
            state.loading = false;
            state.error = null;
            state.success = false;
        },
        // ✅ Add this to manually add leave for testing
        addTestLeave: (state, action) => {
            state.pendingLeaves.push(action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
            // Get Pending Leaves
            .addCase(getAllPendingLeaves.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllPendingLeaves.fulfilled, (state, action) => {
                state.loading = false;
                state.pendingLeaves = action.payload.data || [];
                console.log("✅ Redux State Updated with leaves:", state.pendingLeaves.length);
            })
            .addCase(getAllPendingLeaves.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Failed to fetch leaves';
                console.error("❌ Redux Error:", state.error);
            })
            
            // Get Stats
            .addCase(getLeaveStats.fulfilled, (state, action) => {
                state.stats = action.payload.data || {};
            })
            
            // Update Status
            .addCase(updateLeaveStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateLeaveStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                
                // Remove from pending list
                const updatedLeave = action.payload.data;
                state.pendingLeaves = state.pendingLeaves.filter(
                    leave => leave._id !== updatedLeave._id
                );
            })
            .addCase(updateLeaveStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Failed to update leave';
            });
    }
});

export const { resetAdminLeave, addTestLeave } = adminLeaveSlice.actions;
export default adminLeaveSlice.reducer;